import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import {Card} from 'react-bootstrap';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import Select from 'react-select';
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

// Modal: do you want to save your record
class CreateSchemesMultiple extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            timer: null,
            loading: true,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            is_download: false,
            uploadDropdown: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            scheme_name: null,
            bank_options: [
                { value: 'AMEX BANK', label: 'AMEX BANK'},
                { value: 'AXIS BANK', label: 'AXIS BANK'},
                { value: 'CITIBANK', label: 'CITIBANK'},
                { value: 'HDFC Bank', label: 'HDFC Bank'},
                { value: 'HSBC Bank', label: 'HSBC Bank' },
                { value: 'ICICI Bank', label: 'ICICI Bank' },
                { value: 'INDUSIND BANK', label: 'INDUSIND BANK'},
                { value: 'KOTAK BANK', label: 'KOTAK BANK'},
                { value: 'RBL BANK', label: 'RBL BANK' },
                { value: 'SBI CARD', label: 'SBI CARD' },
                { value: 'STANDARD CHARTERED BANK', label: 'STANDARD CHARTERED BANK'},
                { value: 'YES BANK', label: 'YES BANK'}
            ],
            month_tenure: [
                { value: 3, label: '3 months'},
                { value: 6, label: '6 months'},
                { value: 9, label: '9 months'},
                { value: 12, label: '12 months'},
                { value: 18, label: '18 months' },
                { value: 24, label: '24 months' }
            ],
            selected_bank: [],
            selected_tenure: [],
            cashback_type: 'flat',
            amounter: null,
            max_amounter: null,
            define_max: false,
            is_emi: true,
            is_cashback: false,
            emiMenus:[],
            is_duplicate: null
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        this.getPartyID();
        //var _notificationSystem = this.refs.notificationSystem;
        // this.getBrandUploadedData();
    }

    

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
        });
    }


    getDuplicate(valor){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/check_duplicate_schemes',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id,
                scheme_name: this.state.scheme_name
            }
        }).then(response => {
            console.log(response.data);
            if(response.data.length === 0){
                const token = localStorage.usertoken;
                const decoded = jwt_decode(token);
                const data = new FormData();
                data.append('scheme_name', this.state.scheme_name);
                data.append('bank_name', JSON.stringify(this.state.selected_bank));
                data.append('is_emi', (this.state.is_emi? 1 : 0));
                data.append('user_type', decoded.userGroup);
                if (this.state.is_emi == false){
                    data.append('tenure', 1);
                }
                else{
                    data.append('tenure', JSON.stringify(this.state.selected_tenure));
                }
                data.append('party_master_id', this.state.party_master_id);
                data.append('is_cashback', (this.state.is_cashback? 1 : 0));
                data.append('user_id', decoded._id);
                data.append('brand_sub', this.state.cashback_type);
                data.append('brand_sub_amount', this.state.amounter);
                if (this.state.define_max == false){
                    data.append('max_cashback', -1);
                }
                else{
                    data.append('max_cashback', this.state.max_amounter);
                }
                data.append('is_upfront', 0);
                axios.post(config.get('API_URL') + "/brandemi/create_new_scheme_multiple", data,{
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                .then(res => {
                    console.log(res);
                    if(res.data.data == '1' || res.data.data == 1){
                        this.handleNotificationClick("tr", 1, "Scheme added successfully");
                        this.setState({
                            isSubmit:false,
                            loading:false
                        });

                    } 
                    else {
                        this.handleNotificationClick("tr", 3, res.data.error);
                        this.setState({
                            isSubmit:false,
                            loading:false
                        });
                    }
                })
                .catch(err => { // then print response status
                    this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    })
                });
            }
            else{
                this.handleNotificationClick("tr", 3, "Duplicate Scheme Name");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            }
        });
    }


    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    openInstructions(){
        this.setState({
            open_instructions: !this.state.open_instructions
        });
        
    }

    handleChange(checked) {
        console.log(this.state.checked);
        this.setState({
            checked
        });
    }

    updateBankValues = (valuer) => {
        this.setState({
            selected_bank: valuer,
        });
    };

    updateTenure = (valuer) => {
        this.setState({
            selected_tenure: valuer,
        });
    };

    updateDefineMaxCashback = (valuer) => {
        this.setState({
            define_max: valuer.target.checked,
        });
    };

    updateEMI(checked) {
        this.setState({
            is_emi: checked
        })
    }

    updateCashback(checked) {
        this.setState({
            is_cashback: checked
        })
    }

    updateCashbackType = e => {
        const { name, value } = e.target;
            this.setState({
                [name]: value
            });
    }


    createScheme = () => {
        let vala = this.state.scheme_name;
        let kill = 0;
        this.setState({
            loading: true
        })
        const in_amounter = Number(this.state.amounter);
        const in_max_amounter = Number(this.state.max_amounter);
        console.log(isNaN(this.state.amounter));
        console.log(isNaN(this.state.max_amounter));
        console.log(in_amounter);
        console.log(in_max_amounter);
        if(this.state.scheme_name === '' || this.state.scheme_name === null){
            this.handleNotificationClick("tr", 3, "Enter valid scheme name");
            kill = 1;
        }
        else if(vala.length > 20){
            this.handleNotificationClick("tr", 3, "Max 20 chars for scheme name");
            kill = 1;
        }
        if(this.state.selected_bank== null || this.state.selected_bank.length == 0){
            this.handleNotificationClick("tr", 3, "Select atleast one bank");
            kill = 1;
        }
        if(!this.state.is_emi && !this.state.is_cashback){
            this.handleNotificationClick("tr", 3, "Select atleast one of Avail Zero Cost EMI or Avail Cashback");
            kill = 1;
        }
        if(this.state.is_emi && this.state.selected_tenure == null){
            this.handleNotificationClick("tr", 3, "Select emi tenure");
            kill = 1;
        }
        if(this.state.is_cashback && this.state.cashback_type === 'flat'){
            if (this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
                kill = 1;
            }
            else if(isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
                kill = 1;
            }
            else if(!isNaN(this.state.amounter) && in_amounter <= 0){
                this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
                kill = 1;
            }
        }
        
        if(this.state.is_cashback && this.state.cashback_type === 'percent'){
            if(this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
                kill = 1;
            }
            else if(isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
                kill = 1;
            }
            else if(!isNaN(this.state.amounter) && in_amounter <= 0){
                this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
                kill = 1;
            }
            else if(!isNaN(this.state.amounter) && in_amounter >= 100){
                this.handleNotificationClick("tr", 3, "Cashback percent cannot be greater than 99");
                kill = 1;
            }
        }
        
        
        if(this.state.is_cashback && this.state.cashback_type === 'percent' && this.state.define_max === true){
            if (this.state.max_amounter == '' || this.state.max_amounter == null || isNaN(this.state.max_amounter)){
                this.handleNotificationClick("tr", 3, "Enter valid maximum cashback amount");
                kill = 1;
            }
            else if(isNaN(this.state.max_amounter)){
                this.handleNotificationClick("tr", 3, "Enter max cashback value as digits");
                kill = 1;
            }
            else if(!isNaN(this.state.max_amounter) && in_max_amounter <= 0){
                this.handleNotificationClick("tr", 3, "Enter valid max cashback amount");
                kill = 1;
            }
        }
        
        if (kill == 0){
            this.getDuplicate();
        }
        else{
            this.setState({
                loading: false
            })
        }
    }


    uploadDropdownHandler = () => {
        this.props.history.push('/admin/schemes-list')
    }


    render() {
        // console.log(this.state.party_master_id);
        // console.log(this.state.cashback_type);
        console.log(this.state.selected_bank);

        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            ) 
        });
        

        let bank_options_render = this.state.bank_options;
        let month_tenure_render = this.state.month_tenure;
        let val_to_insert = null;
        let val_holder = null;
        if (this.state.cashback_type == 'flat'){
            val_to_insert = 'Cashback amount';
            val_holder = 'Enter amount';
        }
        else {
            val_to_insert = 'Cashback percentage';
            val_holder = 'Enter percentage';
        }
        let is_emi_render = (this.state.is_emi)? true : false;
        let is_cashback_render = (this.state.is_cashback)? true : false;
        let cashback_type_flat = (this.state.cashback_type === 'flat') ? true : false;
        let cashback_type_percent = (this.state.cashback_type === 'percent') ? true : false;
        let checkboxer = (this.state.is_cashback && this.state.cashback_type == 'percent')  ? true : false;
        let max_cashbacker = (this.state.is_cashback && this.state.define_max) ? true: false;

        return (
            <div className="content longcontent">
                <CommonNavbar/>
            <div className="card-query-builder top-pad-5">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="col-md-12" >
                    <div className="card">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="header">
                            
                            <h4 className="title pull-left">Create new bank scheme</h4>
                            <button onClick={this.uploadDropdownHandler} className="btn-primary nowhiter btn-capitalize3 pull-right">Go back</button>
                            
                        </div>
                        
                        <div className="content">
                            <div className="row top-margin-30">
                                <div className="container-fluid">
                                    <div className="col-md-3">
                                        <Label>Select bank</Label>
                                        <Select name={"bank_name"}
                                            // defaultValue={this.state.selectedMerchValues}
                                            onChange={this.updateBankValues.bind(this)}
                                            options={bank_options_render}
                                            placeholder="Select bank"
                                            isClearable={true}
                                            isMulti
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <Label>Scheme name</Label>
                                        <Input id="campaign_name" className="maxheighter" value={this.state.scheme_name} onChange={(e)=> {
                                            let {scheme_name} = this.state;
                                            scheme_name = e.target.value;
                                            this.setState({
                                                scheme_name: scheme_name,
                                                mapField2: false
                                            })
                                        }}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row top-margin-30">
                                <div className="container-fluid">
                                    <div className="col-md-3">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <Label>Avail Zero Cost EMI</Label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <Switch className="react-switch" height={20} width={38} name="isEMI" onChange={this.updateEMI.bind(this)} checked={is_emi_render}></Switch>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <Label>EMI Tenures (in Months)</Label>
                                        <Select name={"month_tenure"}
                                            // defaultValue={this.state.selectedMerchValues}
                                            onChange={this.updateTenure.bind(this)}
                                            options={month_tenure_render}
                                            placeholder="Select tenure"
                                            isDisabled={!is_emi_render}
                                            isClearable={true}
                                            isMulti
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row top-margin-30">
                                <div className="container-fluid">
                                    <div className="col-md-3">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <Label>Avail Cashback</Label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                            <Switch className="react-switch" height={20} width={38} name="isCashback" onChange={this.updateCashback.bind(this)} checked={is_cashback_render}></Switch>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div className="col-md-3">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <Label>Cashback type</Label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <input type="radio" name="cashback_type" disabled={!is_cashback_render} value="flat" checked={cashback_type_flat} onChange={this.updateCashbackType} /> Flat &nbsp;&nbsp;&nbsp;
                                                <input type="radio" name="cashback_type" disabled={!is_cashback_render} value="percent" checked={cashback_type_percent} onChange={this.updateCashbackType} /> Percentage &nbsp;&nbsp;&nbsp;
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <Label>{val_to_insert}</Label>
                                        <Input id="amounter" className="maxheighter" disabled={!is_cashback_render} placeholder={val_holder} value={this.state.amounter} onChange={(e)=> {
                                            let {amounter} = this.state;
                                            amounter = e.target.value;
                                            this.setState({
                                                amounter: amounter
                                            })
                                        }}/>
                                        <Checkbox number={"define_max"} disabled={!checkboxer} label="Define maximum cashback" onChange={this.updateDefineMaxCashback.bind(this)} checked={!!(this.state.define_max)} />
                                    </div>
                                    <div className="col-md-3">
                                        <Label>Maximum cashback amount</Label>
                                        <Input id="max_amounter" disabled={!max_cashbacker} className="maxheighter" placeholder={"Enter amount"} value={this.state.max_amounter} onChange={(e)=> {
                                            let {max_amounter} = this.state;
                                            max_amounter = e.target.value;
                                            this.setState({
                                                max_amounter: max_amounter
                                            })
                                        }}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row top-margin-30">
                                <div className ="col-md-12">
                                    <button onClick={this.createScheme} className="btn btn-primary btn-capitalize pull-right">Create scheme</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
}

export default CreateSchemesMultiple;